if (!window.__collectionsCarouselInitialized) {
  window.__collectionsCarouselInitialized = true;

  document.addEventListener("DOMContentLoaded", () => {
    initCollectionsCarousels();
    bindCollectionsResize();
  });

  function shouldEnableCarousel() {
    return window.innerWidth > 991;
  }

  function initCollectionsCarousels(scope = document) {
    scope.querySelectorAll(".js-collections-carousel").forEach((element) => {
      if (!shouldEnableCarousel()) {
        destroySingleCarousel(element);
        return;
      }

      if (element.__splideInstance) return;

      const splide = new Splide(element, {
        type: "slide",
        drag: true,
        gap: "16px",
        // Fit every circle on desktop rather than a fixed count, so adding one to
        // snippets/collection-circles.liquid never pushes another off the edge.
        perPage: element.querySelectorAll(".splide__slide").length || 10,
        rewind: false,
        arrows: false,
        pagination: false,

        breakpoints: {
          991: {
            perPage: 6,
            gap: "16px",
          },
          768: {
            perPage: 4,
            gap: "8px",
          },
        },
      });

      splide.mount();
      element.__splideInstance = splide;
      if (typeof window.enableSplideWheelNav === "function") {
        window.enableSplideWheelNav(splide, element);
      }
    });
  }

  function destroySingleCarousel(element) {
    if (element.__splideInstance) {
      element.__splideInstance.destroy(true);
      element.__splideInstance = null;
    }
  }

  function destroyCollectionsCarousels(scope = document) {
    scope.querySelectorAll(".js-collections-carousel").forEach((element) => {
      destroySingleCarousel(element);
    });
  }

  function bindCollectionsResize() {
    let resizeTimer;

    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        document.querySelectorAll(".js-collections-carousel").forEach((element) => {
          destroySingleCarousel(element);
          initCollectionsCarousels(element.parentNode || document);
        });
      }, 150);
    });
  }

  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) => {
      const section = event.target;
      destroyCollectionsCarousels(section);
      initCollectionsCarousels(section);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      destroyCollectionsCarousels(event.target);
    });

    document.addEventListener("shopify:section:select", (event) => {
      const section = event.target;
      destroyCollectionsCarousels(section);
      initCollectionsCarousels(section);
    });

    document.addEventListener("shopify:section:deselect", (event) => {
      const section = event.target;
      destroyCollectionsCarousels(section);
      initCollectionsCarousels(section);
    });
  }
}